<div class="mt-5 overflow-hidden">
  <bdg-label type="title">Dados Pessoais</bdg-label>
  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="Data de nascimento">
      {{ dadosPessoais?.dataNascimento | date: 'dd/MM/yy' }}</bdg-info-label
    >
    <bdg-info-label class="col-6 col-sm-3" label="Sexo">{{ dadosPessoais?.sexo?.descricao }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Nome da mãe">{{
      dadosPessoais?.nomeMae
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Cor/raça">{{
      dadosPessoais?.racaCor?.descricao
    }}</bdg-info-label>
  </div>

  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="RG">{{ dadosPessoais?.rg }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Órgão emissor">{{
      dadosPessoais?.orgaoEmissorRG?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="UF do órgão emissor">{{
      dadosPessoais?.ufEmissoraRG?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Data de emissão do RG">{{
      dadosPessoais?.dataEmissaoRG | date: 'dd/MM/yy'
    }}</bdg-info-label>
  </div>

  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="N° de PIS">{{ dadosPessoais?.pis }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="N° do título de eleitor">{{
      dadosPessoais?.tituloEleitor
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Escolaridade">{{
      dadosPessoais?.escolaridade?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Conselho profissional">{{
      dadosProfissionais?.conselhoProfissional?.descricao
    }}</bdg-info-label>
  </div>

  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="Nº de inscrição primária">{{
      dadosProfissionais?.numeroInscricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Nacionalidade">{{
      dadosPessoais?.nacionalidade?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="País">{{ dadosPessoais?.pais?.descricao }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="UF de naturalidade">{{
      dadosPessoais?.ufNaturalidade?.descricao
    }}</bdg-info-label>
  </div>

  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Município de naturalidade">{{
      dadosPessoais?.municipio?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Tipo sanguíneo">{{
      dadosPessoais?.tipoSanguineo?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Estado civil">{{
      dadosPessoais?.estadoCivil?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Data do primeiro emprego">{{
      dadosPessoais?.dataPrimeiroEmprego | date: 'dd/MM/yy'
    }}</bdg-info-label>
  </div>

  <div class="row mt-4 mb-4">
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Nº de dependentes">{{
      dadosPessoais?.numeroDependentes
    }}</bdg-info-label>
  </div>

  <bdg-label type="title">Endereço</bdg-label>
  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="CEP">{{ dadosComplementares?.endereco?.cep | cep }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Município">{{
      dadosComplementares?.endereco?.municipio?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Logradouro">{{
      dadosComplementares?.endereco?.logradouro
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Complemento">{{
      dadosComplementares?.endereco?.complemento
    }}</bdg-info-label>
  </div>
  <div class="row mt-4 mb-4">
    <bdg-info-label class="col-6 col-sm-3" label="UF">{{
      dadosComplementares?.endereco?.uf?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Bairro">{{ dadosComplementares?.endereco?.bairro }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Número">{{
      dadosComplementares?.endereco?.numero
    }}</bdg-info-label>
  </div>

  <bdg-label type="title">Dados bancários</bdg-label>
  <div class="row mt-4">
    <bdg-label class="col" type="subheading-1">Conta corrente</bdg-label>
  </div>
  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="Banco">{{
      dadosBancarios?.contaCorrente?.banco?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Código da agência">{{
      dadosBancarios?.contaCorrente?.codigoAgencia
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Nº da conta">{{
      dadosBancarios?.contaCorrente?.numeroConta
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Dígito">{{
      dadosBancarios?.contaCorrente?.digitoVerificadorConta
    }}</bdg-info-label>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="border">
        <div class="ml-3 mt-2">
          <bdg-label type="body-1">Comprovante de conta bancária</bdg-label>
        </div>
        <div class="ml-3 mb-2 mt-3 d-flex">
          <bdg-label type="body-1">
            <a
              *ngIf="dadosBancarios?.contaCorrente?.comprovanteAnexo"
              href="javascript:void(0)"
              (click)="download(dadosBancarios?.contaCorrente?.comprovanteAnexo)"
              >{{ dadosBancarios?.contaCorrente?.comprovanteAnexo.nome }}</a
            >
          </bdg-label>
          <mat-icon class="ml-2" *ngIf="dadosBancarios?.contaCorrente?.comprovanteAnexo">get_app</mat-icon>
        </div>
      </div>
    </div>
  </div>
  <div class="row mt-4">
    <bdg-label class="col" type="subheading-1">Conta salário</bdg-label>
  </div>
  <div class="row mt-4">
    <bdg-info-label class="col-6 col-sm-3" label="Banco">{{
      dadosBancarios?.contaSalario?.banco?.descricao
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3" label="Código da agência">{{
      dadosBancarios?.contaSalario?.codigoAgencia
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Nº da conta">{{
      dadosBancarios?.contaSalario?.numeroConta
    }}</bdg-info-label>
    <bdg-info-label class="col-6 col-sm-3 mt-4 mt-sm-0" label="Dígito">{{
      dadosBancarios?.contaSalario?.digitoVerificadorConta
    }}</bdg-info-label>
  </div>
  <div class="row mt-2">
    <div class="col">
      <div class="border">
        <div class="ml-3 mt-2">
          <bdg-label type="body-1">Comprovante de conta bancária</bdg-label>
        </div>
        <div class="ml-3 mb-2 mt-3 d-flex">
          <bdg-label type="body-1">
            <a
              *ngIf="dadosBancarios?.contaSalario?.comprovanteAnexo"
              href="javascript:void(0)"
              (click)="download(dadosBancarios?.contaSalario?.comprovanteAnexo)"
              >{{ dadosBancarios?.contaSalario?.comprovanteAnexo.nome }}</a
            >
          </bdg-label>
          <mat-icon class="ml-2" *ngIf="dadosBancarios?.contaSalario?.comprovanteAnexo">get_app</mat-icon>
        </div>
      </div>
    </div>
  </div>
</div>
